import Button from "../../../components/button/Button";
import ArrowSmall from "../../../components/svg/ArrowSmall";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectOpenBills } from "../../../features/reservation/reservationSlice";
import Payment from "../../../components/kiosk/Payment";
import { resetReservations } from "../../../helpers/reservation";

export default function OpenBillsExpense() {
	const openBills = useSelector(selectOpenBills);
	const navigate = useNavigate();

	return (
		<>
			{openBills && (
				<div className="flex-grow flex justify-center items-center flex-col w-full">
					<div className="text-h1 text-center">
						These have been your consumptions during your stay.
					</div>
					<div className="mt-12 w-full">
						<Payment
							openBills={openBills}
							minimalAmount={0}
							callBack={() => navigate("/kiosk/check-expense/confirmation")}
						/>
					</div>
					{openBills.Total.GrossValue <= 0 && (
						<div className="mt-6 flex justify-between items-center w-full text-h3 text-center">
							<Button
								onClick={() => resetReservations()}
								type="button"
								text="Close"
								suffix={<ArrowSmall />}
							/>
						</div>
					)}
				</div>
			)}
		</>
	);
}
